import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const PreviewCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;

  width: 100%;
  height: 245px;

  border: 1px solid ${globals.MOON_200};
  border-radius: 8px;

  font-weight: 600;
  font-size: 18px;
  line-height: 23px;

  overflow: hidden;
`;

export const PreviewWrapper = styled.div`
  margin-top: 10px;

  max-width: 375px;
  max-height: 100%;
  border-radius: 8px;

  overflow: hidden;
`;

export const WandbText = styled.span`
  color: ${globals.MOON_800};
  margin-bottom: 4px;
`;

export const PreviewTitle = styled.span`
  color: ${globals.TEAL_600};
`;

export const PreviewDescriptionText = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${globals.MOON_650};
`;

export const StyledImg = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: 0 0;
`;
